<template>
  <vx-card class="lg:p-8 w-full lg:w-9/12 fadeInLeft">
    <div class="vx-card__title mb-4">
      <h4 class="mb-4">Восстановление пароля</h4>
      <p>Введите новый пароль</p>
    </div>
    <div class="mb-6">
      <password-input
        label="Новый пароль:"
        name="password"
        v-model="password"
        v-validate="'required|min:8'"
        ref="password"
        class="w-full" />
      <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
    </div>

    <div class="mb-6">
      <password-input
        label="Подтвердить пароль:"
        name="password_confirmation"
        v-model="password_confirmation"
        data-vv-as="password"
        v-validate="'required|confirmed:password'"
        class="w-full" />
      <span class="text-danger text-sm" v-show="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>
    </div>

    <div class="flex flex-wrap justify-between items-center">
      <vs-button @click.prevent="send" v-if="!success">Поменять пароль</vs-button>
      <vs-button type="border" :to="{name: 'login'}" v-else>Войти</vs-button>
    </div>
  </vx-card>
</template>

<script>
import Auth from '../../api/http/models/auth/Auth'

export default  {
  data () {
    return {
      email: '',
      token: '',
      password: '',
      password_confirmation: '',
      success: false
    }
  },

  created () {
    this.token = this.$route.query.token
    this.email = this.$route.query.email
  },

  methods: {
    async send () {
      const validate = await this.$validator.validateAll()

      if (validate) {
        const response = await Auth.reset({
          email: this.email,
          token: this.token,
          password: this.password
        })

        if (response.status === 'success') {
          this.$vs.notify({
            color: 'success',
            title: 'Ваш пароль успешно обновлен',
            text: ''
          })
          this.success = true
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Произошла ошибка',
            text: ''
          })
        }
      }
    }
  }
}
</script>
